var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#star_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.433 3.482a.764.764 0 0 1 1.42 0l1.88 4.699c.11.273.366.46.659.48l5.036.342c.688.047.968.912.44 1.355l-3.875 3.247a.769.769 0 0 0-.251.776l1.232 4.912c.168.67-.565 1.205-1.15.837l-4.274-2.693a.763.763 0 0 0-.814 0L8.461 20.13c-.584.368-1.317-.166-1.149-.837l1.232-4.912a.769.769 0 0 0-.252-.776l-3.874-3.247c-.529-.443-.249-1.308.44-1.355l5.036-.342a.765.765 0 0 0 .658-.48l1.88-4.7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.788 3.088c.568-1.154 2.268-1.116 2.761.115l1.88 4.7.014.01 5.037.342.125.014c1.232.179 1.723 1.713.838 2.58l-.094.084-3.874 3.247a.02.02 0 0 0-.006.02l1.232 4.91.026.123c.208 1.222-1.088 2.178-2.193 1.595l-.109-.063-4.275-2.693h-.014l-4.275 2.693c-1.163.732-2.608-.335-2.277-1.655l1.233-4.91-.006-.02-3.874-3.247c-1.043-.875-.497-2.585.869-2.678l5.037-.343.013-.01 1.88-4.699.052-.115Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "star_svg__a",
    x: 0.641,
    y: 0.5,
    width: 25.003,
    height: 24.256,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.118316 0 0 0 0 0.153551 0 0 0 0 0.195833 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2794_6194"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2794_6194",
    result: "shape"
  })))));
};

export default SvgStar;